import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
};

const otherregionstorelistSlice = createSlice({
  name: "otherregionstoreList",
  initialState,
  reducers: {
    setOtherregionStorelist: (state, action) => {
      state.list = action.payload;
    },
    clearOtherregionStorelist: (state) => {
      state.list = [];
    },
    addOrReplaceOtherregionStorelist: (state, action) => {
      const item = action.payload;
      const index = state.list.findIndex(store => store.Storeid === item.Storeid);
      if (index !== -1) {
        // Replace existing item
        state.list[index] = item;
      } else {
        // Add new item
        state.list.push(item);
      }
    },
  },
});

export const {
  setOtherregionStorelist,
  clearOtherregionStorelist,
  addOrReplaceOtherregionStorelist
} = otherregionstorelistSlice.actions;

export default otherregionstorelistSlice.reducer;
